import styled from "styled-components";

export const ListItem = styled.li`
    margin-top: var(--spacing-1);
    &:first-child {
        margin: 0;
    }
`;
